<template>
  <div v-if="isDesktop"
       class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage">
    <div class="sidebar-wrapper">
      <div class="logo">
        <a href="#" class="simple-text logo__container">
          <img style="width: 130px; margin-left: 37px;" src="img/logo-v2.png" alt="">
        </a>
      </div>

      <slot name="content"></slot>

      <ul class="nav nav-main__links">
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        @click="closeNavbar"
                        :link="link">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </sidebar-link>
        </slot>
      </ul>

      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarLink from './SidebarLink.vue'

export default {
  components: {
    SidebarLink
  },
  props: {
    title: { type: String, default: 'Vue LBD' },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'].includes(value)
    },
    backgroundImage: { type: String, default: 'img/sidebar-5.jpg' },
    sidebarLinks: { type: Array, default: () => [] },
    autoClose: { type: Boolean, default: true }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= 768;
    },
    sidebarStyle() {
      return {};
    }
  },
  mounted() {
    // Listen for window resize to update visibility dynamically
    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    // Clean up listener to prevent memory leaks
    window.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    closeNavbar() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
}
</script>

<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar .nav-main__links {
  flex: 1;
}

.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}
</style>
